import { render, staticRenderFns } from "./customTable.vue?vue&type=template&id=2a4e281e&scoped=true"
import script from "./customTable.vue?vue&type=script&lang=js"
export * from "./customTable.vue?vue&type=script&lang=js"
import style0 from "./customTable.vue?vue&type=style&index=0&id=2a4e281e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4e281e",
  null
  
)

export default component.exports